import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import LandingLayout from '../layouts/landing_layout'

class LandingPage extends React.PureComponent {

  render() {
    const { children } = this.props
    return (
      <LandingLayout>
        <PageTitle path='Gab.com' />
        {children}
      </LandingLayout>
    )
  }

}

LandingPage.propTypes = {
  children: PropTypes.node.isRequired,
  noRightSidebar: PropTypes.bool,
}

export default LandingPage